import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars'
import axios from 'axios';
import Select from 'react-select';
import $ from 'jquery';
const ViewPrice = (props) => {

    const [items, setitems] = useState([]);
    const [addunit, setunit] = useState([])
    const [addshift, setshift] = useState([])
    const [unitvalue, setunitvalue] = useState()
    const [shiftvalue, setshiftvalue] = useState()
    const [isCheckedmon, setIsCheckedmon] = useState(false);
    const [isCheckedtue, setIsCheckedtue] = useState(false);
    const [isCheckedwed, setIsCheckedwed] = useState(false);
    const [isCheckedthur, setIsCheckedthur] = useState(false);
    const [isCheckedfri, setIsCheckedfri] = useState(false);
    const [isCheckedsat, setIsCheckedsat] = useState(false);
    const [isCheckedsun, setIsCheckedsun] = useState(false);
    const [isCheckedhol, setIsCheckedhol] = useState(false);
    const url = process.env.REACT_APP_APIURL + "Pricing/GetPricings?companyid=" + props.companyid;
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        }, 100)

    }, []);
    useEffect(() => {

        $('#example3').DataTable();
    }, [items]);

    useEffect(() => {
        fetchUnitdata()
        fetchShiftdata()
    }, []);

    async function fetchUnitdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }
    async function fetchShiftdata() {
        const Shifturl = process.env.REACT_APP_APIURL + "Shift/GetPshifts?companyid=" + props.companyid;
        let Shiftdata = await axios.get(Shifturl);
        var shifts = [];
        Shiftdata.data.map((u) => {
            shifts.push({ value: u.shiftId, label: u.shiftName });
        })
        setshift(shifts);
    }
    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result =>

            setitems(result)
        );
    }
    async function deletedata(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'Pricing/DeletePricing?Pricing_ID=' + id
        let res = await axios.post(urldelete)
        if (res.status == 200) {
            swal({
                title: "Deleted Successfully",
                icon: "success"
            })
            populatedata();

        }
    }

    async function handleEdit(id) {
        debugger;
        const newurl = process.env.REACT_APP_APIURL + "Pricing/GetPricing?Pricing_ID=" + id + "&companyid=" + props.companyid;
        await fetch(newurl).then(res => res.json()).then(result => {

            setupdateitems({ ...updateitems, Pricing_ID: result.pricing_ID, Shift_ID: result.shift_ID, ShiftName: result.shift_Name, UnitId: result.unitId, UnitName: result.unit_Name, Amount: result.amount, company_id: props.companyid, mon: result.mon, tue: result.tue, thur: result.thur, wed: result.wed, fri: result.fri, sat: result.sat, sun: result.sun, hol: result.hol })
            setshiftvalue({ value: result.shift_ID, label: result.shift_Name })
            setunitvalue({ value: result.unit_Id, label: result.unit_Name })
           
            if (result.mon == "mon") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedmon != true) {
                    setIsCheckedmon(!isCheckedmon);
                }
               
            }
            else {
                setIsCheckedmon(false);
            }
            if (result.tue == "tue") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedtue != true) {
                    setIsCheckedtue(!isCheckedtue);
                }
            }
            else {
                setIsCheckedtue(false);
            }
            if (result.wed == "wed") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedwed != true) {
                    setIsCheckedwed(!isCheckedwed);
                }
            }
            else {
                setIsCheckedwed(false);
            }
            if (result.thur == "thur") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedthur != true) {
                    setIsCheckedthur(!isCheckedthur);
                }
            }
            else {
                setIsCheckedthur(false);
            }
            if (result.fri == "fri") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedfri != true) {
                    setIsCheckedfri(!isCheckedfri);
                }
            }
            else {
                setIsCheckedfri(false);
            }
            if (result.sat == "sat") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedsat != true) {
                    setIsCheckedsat(!isCheckedsat);
                }
            }
            else {
                setIsCheckedsat(false);
            }
            if (result.sun == "sun") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedsun != true) {
                    setIsCheckedsun(!isCheckedsun);
                }
            }
            else {
                setIsCheckedsun(false);
            }
            if (result.hol == "hol") {
                //this.name["mon"].checked = !this.name["mon"].checked;
                if (isCheckedhol != true) {
                    setIsCheckedhol(!isCheckedhol);
                }
            }
            else {
                setIsCheckedhol(false);
            }
        });
        $("#myModal").modal("show")
    }
    function handleDelete(id) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                deletedata(id);

            } else {
                swal("0 Rows deleted");
            }
        });
    }
    /////////////////////////////////////////////////////
    ////////////////UPDATE SHIFT/////////////////////////
    /////////////////////////////////////////////////////
    const [updateitems, setupdateitems] = useState({ Pricing_ID: "", Shift_ID: "", UnitId: "", Amount: "", mon: "", tue: "", wed: "", thur: "", fri: "", sat: "", sun: "", hol: "", company_id: props.companyid })
    
    const [daystypevalue, setdaystypevalue] = useState()
    const [daystype, setdaystype] = useState([
        { label: "Weekdays", value: "1" },
        { label: "Weekends", value: "2" }
    ])
    useEffect(() => {

    }, []);
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        debugger;
        if (name == "mon" || name == "tue" || name == "wed" || name == "thur" || name == "fri" || name == "sat" || name == "sun" || name == "hol") {
            if (e.target.checked) {
                if (name == "mon") {
                    setIsCheckedmon(!isCheckedmon);
                }
                else if (name == "tue") {
                    setIsCheckedtue(!isCheckedtue);
                }
                else if (name == "wed") {
                    setIsCheckedwed(!isCheckedwed);
                }
                else if (name == "thur") {
                    setIsCheckedthur(!isCheckedthur);
                }
                else if (name == "fri") {
                    setIsCheckedfri(!isCheckedfri);
                }
                else if (name == "sat") {
                    setIsCheckedsat(!isCheckedsat);
                }
                else if (name == "sun") {
                    setIsCheckedsun(!isCheckedsun);
                }
                else if (name == "hol") {
                    setIsCheckedhol(!isCheckedhol);
                }
                setupdateitems({ ...updateitems, [name]: value })
            }
            else {
                if (name == "mon") {
                    setIsCheckedmon(false);
                }
                else if (name == "tue") {
                    setIsCheckedtue(false);
                }
                else if (name == "wed") {
                    setIsCheckedwed(false);
                }
                else if (name == "thur") {
                    setIsCheckedthur(false);
                }
                else if (name == "fri") {
                    setIsCheckedfri(false);
                }
                else if (name == "sat") {
                    setIsCheckedsat(false);
                }
                else if (name == "sun") {
                    setIsCheckedsun(false);
                }
                else if (name == "hol") {
                    setIsCheckedhol(false);
                }
                setupdateitems({ ...updateitems, [name]: "" })
            }

        }
        else {
            setupdateitems({ ...updateitems, [name]: value })
        }
       
    }
   
    const refresh = () => {
        setupdateitems({ ...updateitems, Pricing_ID: "", Shift_ID: "", UnitId: "", Amount: "", mon: "", tue: "", wed: "", thur: "", fri: "", sat: "", sun: "", hol: "", company_id: props.companyid });
       
        setunitvalue(null)
        setshiftvalue(null)
      //  setdaystypevalue(null)
    }
    const savemethod = async (data) => {
        debugger;
        const url = process.env.REACT_APP_APIURL + "Pricing/UpdatePricing";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();
                populatedata();
                $("#myModal").modal("hide");
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger;
        savemethod(updateitems);
        // console.log(items);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                        <div className="card-header">
                        <h3 className="me-auto mb-0">View Pricing List</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Unit Id</th>
                                        <th>Unit Name</th>
                                        <th>Days</th>
                                        <th>Shift Name</th>
                                        <th>Amount</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>

                                        <tr key={item.pricing_ID}>
                                            <td>{item.unitId}</td>
                                            <td>{item.unit_Name}</td>
                                            <td>{item.alldays }</td>
                                            <td>{item.shift_Name}</td>
                                            <td>{item.amount}</td>
                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                        onClick={(id) => handleEdit(item.pricing_ID)}>
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                        onClick={(id) => handleDelete(item.pricing_ID)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Update Shift</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-3 col-sm-12 col-lg-12 viz">
                                                <label htmlFor="unit_name" className="form-label">Shifts</label>
                                                <Select name="shift" autoComplete="off" value={shiftvalue} options={addshift} onChange={(e) => { setshiftvalue(e); setitems({ ...items, ShiftId: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12 viz">
                                                <label htmlFor="unit_name" className="form-label">Unit</label>
                                                <Select name="unit" autoComplete="off" value={unitvalue} options={addunit} onChange={(e) => { setunitvalue(e); setitems({ ...items, UnitId: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="amount_name" className="form-label">Amount</label>
                                                <input type="text" className="form-control" name="Amount" value={updateitems.Amount} onChange={handleInput} required />
                                            </div>

                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="timepicker2">Day</label>
                                                {/* <Select value={daystypevalue} options={daystype} onChange={(e) => { setdaystypevalue(e); setitems({ ...items, daystype: e.value }) }} />*/}
                                                <div className="checkbox-group" id="checkboxes">
                                                    <ul>
                                                        <li>
                                                            <input type="checkbox" id="mon" name="mon" value="mon" onChange={handleInput} checked={isCheckedmon} />
                                                            <label htmlFor="mon">MON</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="tue" name="tue" value="tue" onChange={handleInput} checked={isCheckedtue}/>
                                                            <label htmlFor="tue">TUE</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="wed" name="wed" value="wed" onChange={handleInput} checked={isCheckedwed}/>
                                                            <label htmlFor="wed">WED</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="thur" name="thur" value="thur" onChange={handleInput} checked={isCheckedthur}/>
                                                            <label htmlFor="thur">THUR</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="fri" name="fri" value="fri" onChange={handleInput} checked={isCheckedfri}/>
                                                            <label htmlFor="fri">FRI</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="sat" name="sat" value="sat" onChange={handleInput} checked={isCheckedsat}/>
                                                            <label htmlFor="sat">SAT</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="sun" name="sun" value="sun" onChange={handleInput} checked={isCheckedsun}/>
                                                            <label htmlFor="sun">SUN</label>
                                                        </li>
                                                        <li>
                                                            <input type="checkbox" id="hol" name="hol" value="hol" onChange={handleInput} checked={isCheckedhol}/>
                                                            <label htmlFor="hol">HOLIDAY</label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <input type="submit" className="btn btn-primary" value="Save" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ViewPrice;